import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import './Profile.css';

const Profile: React.FC = () => {
  const { state, dispatch } = useApp();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    firstName: state.user?.firstName || '',
    lastName: state.user?.lastName || '',
    email: state.user?.email || '',
    phone: state.user?.phone || ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = () => {
    // In a real app, this would update the user via API
    const updatedUser = {
      ...state.user!,
      ...formData
    };
    dispatch({ type: 'LOGIN', payload: updatedUser });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setFormData({
      firstName: state.user?.firstName || '',
      lastName: state.user?.lastName || '',
      email: state.user?.email || '',
      phone: state.user?.phone || ''
    });
    setIsEditing(false);
  };

  if (!state.user) {
    return (
      <div className="profile-page">
        <div className="container">
          <div className="not-logged-in">
            <h1>Please log in to view your profile</h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <div className="container">
        <div className="profile-header">
          <h1>My Profile</h1>
          <p>Manage your account information and preferences</p>
        </div>

        <div className="profile-content">
          <div className="profile-card">
            <div className="card-header">
              <h2>Personal Information</h2>
              {!isEditing ? (
                <button onClick={() => setIsEditing(true)} className="edit-btn">
                  Edit Profile
                </button>
              ) : (
                <div className="edit-actions">
                  <button onClick={handleSave} className="save-btn">Save</button>
                  <button onClick={handleCancel} className="cancel-btn">Cancel</button>
                </div>
              )}
            </div>

            <div className="profile-form">
              <div className="form-row">
                <div className="form-group">
                  <label>First Name</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                  ) : (
                    <div className="form-value">{state.user.firstName}</div>
                  )}
                </div>

                <div className="form-group">
                  <label>Last Name</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                  ) : (
                    <div className="form-value">{state.user.lastName}</div>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label>Email Address</label>
                {isEditing ? (
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                ) : (
                  <div className="form-value">{state.user.email}</div>
                )}
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                {isEditing ? (
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                  />
                ) : (
                  <div className="form-value">{state.user.phone || 'Not provided'}</div>
                )}
              </div>
            </div>
          </div>

          <div className="profile-card">
            <div className="card-header">
              <h2>Account Statistics</h2>
            </div>
            
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">{state.cart.length}</div>
                <div className="stat-label">Items in Cart</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">0</div>
                <div className="stat-label">Orders Placed</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">Member</div>
                <div className="stat-label">Account Status</div>
              </div>
            </div>
          </div>

          <div className="profile-card">
            <div className="card-header">
              <h2>Account Actions</h2>
            </div>
            
            <div className="actions-list">
              <button className="action-btn secondary">Change Password</button>
              <button className="action-btn secondary">Download Data</button>
              <button 
                className="action-btn danger"
                onClick={() => dispatch({ type: 'LOGOUT' })}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
